// Il menu a gruppi richiudibili (tela, artboard 39; spec «Struttura della plancia»): in alto la
// Dashboard, poi Lavoro e Risorse (che si apre con i Pops), ognuno con le sue sezioni. Le
// notifiche stanno nella campanella dell'intestazione, Impostazioni in fondo.
/** il colore pop di una voce: fondino e icona (token `--pop-*`) */
export type Tint = 'blue' | 'lilac' | 'pink' | 'coral' | 'mint' | 'sun';

export interface NavLeaf {
  to: string;
  label: string;
  icon: string;
  tint?: Tint;
}

export interface NavGroupDef {
  id: string;
  label: string;
  icon: string;
  tint?: Tint;
  sections: { label: string; items: NavLeaf[] }[];
}

export const NAV_TOP: NavLeaf[] = [
  { to: '/', label: 'Dashboard', icon: 'layout-dashboard', tint: 'lilac' },
  { to: '/conversazioni', label: 'Conversazioni', icon: 'messages-square', tint: 'blue' },
];

export const NAV_GROUPS: NavGroupDef[] = [
  {
    id: 'work',
    label: 'Lavoro',
    icon: 'clipboard-list',
    tint: 'mint',
    sections: [
      {
        label: 'In corso',
        items: [
          { to: '/progetti', label: 'Progetti', icon: 'folder', tint: 'mint' },
          { to: '/pianifica', label: 'Pianifica', icon: 'calendar-clock', tint: 'sun' },
          { to: '/runtime', label: 'Runtime', icon: 'activity', tint: 'coral' },
        ],
      },
      {
        label: 'Storico',
        items: [
          { to: '/archivio', label: 'Archivio', icon: 'box', tint: 'lilac' },
          { to: '/consumi', label: 'Consumi', icon: 'coins', tint: 'sun' },
        ],
      },
    ],
  },
  {
    id: 'resources',
    label: 'Risorse',
    icon: 'hard-drive',
    tint: 'pink',
    sections: [
      { label: 'Crew', items: [{ to: '/pops', label: 'Pops', icon: 'users-round', tint: 'pink' }] },
      {
        label: 'Modelli e strumenti',
        items: [
          { to: '/providers', label: 'Provider', icon: 'server', tint: 'blue' },
          { to: '/strumenti', label: 'Strumenti', icon: 'wrench', tint: 'coral' },
        ],
      },
      {
        label: 'Collegamenti',
        items: [
          { to: '/git', label: 'Git', icon: 'git-fork', tint: 'mint' },
          { to: '/integrazioni', label: 'Integrazioni', icon: 'plug-zap', tint: 'lilac' },
        ],
      },
    ],
  },
];

export function isActive(to: string, pathname: string): boolean {
  if (to === '/') return pathname === '/' || pathname.startsWith('/s/');
  return pathname.startsWith(to);
}

export function groupOf(pathname: string): string | null {
  const g = NAV_GROUPS.find((g) =>
    g.sections.some((s) => s.items.some((i) => isActive(i.to, pathname))),
  );
  return g?.id ?? null;
}

// quali gruppi sono aperti lo ricorda il browser; senza scelta, aperto quello della pagina
const OPEN_KEY = 'poptown.nav.open';

export function readOpen(): Record<string, boolean> {
  try {
    const raw: unknown = JSON.parse(localStorage.getItem(OPEN_KEY) ?? '{}');
    return raw && typeof raw === 'object' ? (raw as Record<string, boolean>) : {};
  } catch {
    return {};
  }
}

export function saveOpen(open: Record<string, boolean>): void {
  try {
    localStorage.setItem(OPEN_KEY, JSON.stringify(open));
  } catch {
    // senza storage il menu funziona lo stesso, solo non ricorda
  }
}
